import { MrbModalParams } from "mrb/common";
import { UUID } from "common/utils";
import { action, observable, makeObservable, toJS } from "mobx";
import { MrbBaseViewStore } from "mrb/core";

class LoadioStoreFeaturedSectionViewStore extends MrbBaseViewStore {
    itemLimit = 10;

    @observable items = [];

    @observable isSubmitting = false;

    constructor(rootStore, { routeStore }) {
        super(rootStore);
        makeObservable(this);
        this.routeStore = routeStore;

        this.editItemModalParams = new MrbModalParams(
            {},
            {
                routeStore: this.routeStore,
            }
        );
        this.editItem = this.editItem.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.addItem = this.addItem.bind(this);
        this.addItemModalFunction = this.addItemModalFunction.bind(this);
    }

    onInit() {
        return this.getFeatured();
    }

    @action.bound
    async getFeatured() {
        try {
            const list = await this.routeStore.getFeatured();
            this.setList(list);
        } catch (err) {
            this.rootStore.notificationStore.error(
                "An unexpected error occurred while trying to load featured section data. Please contact the support team."
            );
        }
    }

    @action.bound
    setIsSubmitting(value) {
        this.isSubmitting = value;
    }

    @action.bound
    async updateFeatured() {
        try {
            this.setIsSubmitting(true);
            await this.routeStore.updateFeatured(this.items);

            const list = await this.routeStore.getFeatured();
            this.setList(list);
        } catch (err) {
            this.rootStore.notificationStore.error(
                "An unexpected error occurred while trying to update featured section. Please contact the support team."
            );
        } finally {
            this.setIsSubmitting(false);
        }
    }

    @action.bound
    setList(items) {
        this.items = items;
        this.updateItemOrder();
    }

    editItem(item) {
        this.editItemModalParams.open({
            item: item,
        });
    }

    addItemModalFunction() {
        this.editItemModalParams.open({
            shouldAdd: true,
            addItem: this.addItem,
        });
    }

    addItem(item) {
        item.id = UUID.create();
        var items = [...this.items, item];
        this.setList(items);
    }

    updateItemOrder() {
        this.items.forEach((item, index) => {
            item.sortOrder = index + 1;
        });
    }

    @action.bound
    reorderItems(result) {
        const { destination, source } = result;
        if (!destination) {
            return;
        }

        if (destination.droppableId === source.droppableId && destination.index === source.index) {
            return;
        }

        const newItems = Array.from(toJS(this.items));
        const item = newItems.splice(source.index, 1)[0];
        newItems.splice(destination.index, 0, item);

        this.setList(newItems);
    }

    removeItem(item) {
        var items = this.items.filter((listItem) => listItem.sortOrder !== item.sortOrder);
        this.setList(items);
    }
}

export default LoadioStoreFeaturedSectionViewStore;
